import React from 'react'
import './Button.css'

/**
 * Reusable Button Component
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Button content
 * @param {string} props.variant - Button variant (primary, secondary, info, success, warning, danger, outlined, text)
 * @param {string} props.size - Button size (small, medium, large)
 * @param {boolean} props.disabled - Disabled state
 * @param {boolean} props.loading - Loading state
 * @param {React.ReactNode} props.icon - Icon element to display before text
 * @param {Function} props.onClick - Click handler
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.type - Button type (button, submit, reset)
 */
const Button = ({
	children,
	variant = 'primary',
	size = 'medium',
	disabled = false,
	loading = false,
	icon,
	onClick,
	className = '',
	type = 'button',
	...props
}) => {
	const baseClass = 'btn'
	const classes = [
		baseClass,
		`${baseClass}--${variant}`,
		`${baseClass}--${size}`,
		loading && `${baseClass}--loading`,
		disabled && `${baseClass}--disabled`,
		className,
	]
		.filter(Boolean)
		.join(' ')

	return (
		<button
			type={type}
			className={classes}
			disabled={disabled || loading}
			onClick={onClick}
			{...props}
		>
			{loading ? (
				<span className={`${baseClass}__spinner`}>Loading...</span>
			) : (
				<>
					{icon}
					{children}
				</>
			)}
		</button>
	)
}

export default Button
